<template lang="html">
  <section class="text text--negro4" v-if="nota._id">

    <div class="grid">
      <div class="col-md-12">
        <h1 class="h2">{{ nota.titulo }}</h1>
      </div>
      <div class="col-md-8">
        <div class="grid grid--bleed">
          <div class="col-md-6">
            <div class="form__group">
              <label class="form__label text--bold">Fecha</label>
              <p class="form__input">{{ nota.guionId.fecha | fecha('LL') }}</p>
            </div>
            <div class="form__group">
              <label class="form__label text--bold">Medio:</label>
              <p class="form__input">{{ nota.guionId.medio.nombre }}</p>
            </div>

            <div v-if="nota.guionId.programa" class="form__group">
              <label class="form__label text--bold">Programa:</label>
              <p class="form__input">{{ nota.guionId.programa.nombre }}</p>
            </div>

            <div v-if="nota.seccion" class="form__group">
              <label class="form__label text--bold">Sección:</label>
              <p class="form__input">{{ nota.seccion.nombre }}</p>
            </div>

            <div v-if="nota.guionId.programa && nota.edicion" class="form__group">
              <label class="form__label text--bold">Edición:</label>
              <p class="form__input">{{ nota.edicion.nombre }}</p>
            </div>

            <div v-if="nota.guionId.programa" class="form__group">
              <label class="form__label text--bold">Hora:</label>
              <p class="form__input">{{ nota.hora | fecha('hh:mm') }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form__group">
              <label class="form__label text--bold">Tipo de Mención:</label>
              <p class="form__input">{{ cliente.mencion }}</p>
            </div>

            <div class="form__group">
              <label class="form__label text--bold">Aparece logo:</label>
              <p class="form__input" v-if="cliente.logo">SÍ</p>
              <p class="form__input" v-else>NO</p>
            </div>

            <div class="form__group">
              <label class="form__label text--bold">eVcom:</label>
              <p class="form__input" v-if="!nota.multimedia">Pendiente</p>
              <p class="form__input" v-if="nota.multimedia">
                {{ calcularEVcom(nota) | colones }}
              </p>
            </div>

            <div class="form__group">
              <label class="form__label text--bold">Alcance:</label>
              <p class="form__input">{{ alcance(nota) }}</p>
            </div>

            <div v-if="nota.transcripcion.abstract" class="form__group">
              <label class="form__label text--bold">Abstract:</label>
              <p class="form__input">{{ nota.transcripcion.abstract }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="min-height">
          <div v-if="nota.multimedia" class="text--center">
            <div v-if="tipoArchivo === 'video'">
              <video controls>
                <source :src="nota.archivo.S3url" type="video/mp4">
                <p>Your browser does not support the video tag.</p>
              </video>
            </div>
            <div v-if="tipoArchivo === 'audio'">
              <audio :src="nota.archivo.S3url" preload="auto" controls />
            </div>
            <div v-if="tipoArchivo === 'image'">
              <img class="img-responsive" :src="nota.archivo.S3url">
            </div>
            <br>
            <div v-if="tipoArchivo === 'application'">
              <div class="mostrar-archivo">
                <p v-if="mostrarArchivo" @click="mostrarArchivo = !mostrarArchivo">
                  <span>Esconder PDF</span>
                  <i class="fa fa-fw fa-chevron-up"/>
                </p>
                <p v-if="!mostrarArchivo" @click="mostrarArchivo = !mostrarArchivo">
                  <span>Mostrar PDF</span>
                  <i class="fa fa-fw fa-chevron-down"/>
                </p>
              </div>
              <div v-show="mostrarArchivo">
                <iframe
                  :src="`https://docs.google.com/gview?url=${nota.archivo.S3url}&embedded=true`"
                  style="width:95%; min-height:600px; margin: 0 auto;" frameborder="0"/>
              </div>
            </div>
            <br>
            <div>
              <a class="boton boton--rojo" :href="nota.archivo.S3url">
                <i class="fal fa-download" aria-hidden="true"/>
                <span class="hidden-xs">Descargar Multimedia</span>
              </a>
            </div>
          </div>
          <div v-else class="text--center">
            El contenido multimedia para esta nota aún no está disponible.
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-md-4">
        <section>
          <h4 class="h4 text--rojo">Entidades</h4>
          <ul class="ul-notas__box">
            <li v-for="entidad in entidades.docs" :key="entidad._id">
              <span class="text--small text">{{ entidad.nombre }}</span>
            </li>
          </ul>
          <p class="text text--grisa" v-show="!entidades.contador">
            No hay entidades asociadas a esta nota.
          </p>
        </section>
      </div>
      <div class="col-md-4">
        <h4 class="h4 text--rojo">Personajes</h4>
        <ul class="ul-notas__box">
          <li v-for="personaje in personajes.docs" :key="personaje._id">
            <span class="text text--small">{{ personaje.nombre }} {{ personaje.apellido }}</span>
          </li>
        </ul>
        <p class="text text--grisa" v-show="!personajes.contador">
          No hay personajes asociados a esta nota.
        </p>
      </div>
      <div class="col-md-4">
        <div>
          <h4 class="h4 text--rojo">Etiquetas</h4>
          <ul class="ul-notas__box">
            <li v-for="etiqueta in nota.etiquetas" :key="etiqueta._id">
              <span class="text text--small">{{ etiqueta }}</span>
            </li>
          </ul>
          <p class="text text--grisa" v-show="!nota.etiquetas.length">
            No hay etiquetas asociadas a esta nota.
          </p>
        </div>
      </div>
    </div>
    <div class="grid" v-if="nota.transcripcion.transcripcion">
      <div class="col-sm-12">
        <h4 class="h4 text--rojo">Transcripción</h4>
        <textarea class="text transcripcion"
                  disabled="disabled"
                  v-model="nota.transcripcion.transcripcion"/>
      </div>
    </div>
  </section>
</template>

<script>
import isNaN from "lodash/isNaN";
import isNil from "lodash/isNil";
import find from "lodash/find";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import ArchivoAPI from "./rest/archivoApi";
import NotaAPI from "./rest/notasApi";
import TranscripcionAPI from "./rest/transcripcionApi";

function data() {
  return {
    nota: {},
    cliente: {},
    tipoArchivo: null,
    entidades: { docs: [] },
    personajes: { docs: [] },
    mostrarArchivo: false,
  };
}

function getEntidades(entidades) {
  const entidadesIds = { ids: map(entidades, "_id") };
  return NotaAPI.getEntidadesBulkPublicas(entidadesIds);
}

function getPersonajes(personajes) {
  const personajesIds = { ids: map(personajes, "_id") };
  return NotaAPI.getPersonajesBulkPublicas(personajesIds);
}

function created() {
  const { params, query } = this.$router.currentRoute;
  return NotaAPI.obtenerPublica(params.id).then((nota) => {
    if (query.clienteId) {
      this.cliente = find(nota.clientes, { _id: query.clienteId });
    }
    if (nota.guionId.programa) {
      nota.edicion = find(nota.guionId.programa.ediciones, { _id: nota.guionId.edicion });
    }
    const promesas = [
      getEntidades(nota.entidades),
      getPersonajes(nota.personajes),
      TranscripcionAPI.obtenerDesdeNotas([nota._id]),
    ];
    if (nota.multimedia) {
      promesas.push(ArchivoAPI.obtener(nota.multimedia._id));
    }
    return Promise.all(promesas).then(([entidades, personajes, transcripcion, archivo]) => {
      this.entidades = entidades;
      this.personajes = personajes;
      if (!isEmpty(transcripcion)) {
        nota.transcripcion = {
          transcripcion: transcripcion[0].transcripcion,
          abstract: transcripcion[0].abstract,
        };
      }
      if (!isEmpty(archivo)) {
        nota.archivo = archivo;
        this.tipoArchivo = nota.archivo.mymeType.split("/")[0]; // eslint-disable-line
      }
      this.nota = nota;
      return null;
    });
  });
}

function obtenerEdicion(nota) {
  return find(nota.guionId.programa.ediciones, { _id: nota.guionId.edicion });
}

function tamanoToInt(tamano) {
  switch (tamano) {
    case "1/2":
      return 1 / 2.0;
    case "1/3":
      return 1 / 3.0;
    case "1/4":
      return 1 / 4.0;
    case "3/4":
      return 3 / 4.0;
    case "1/8":
      return 1 / 8.0;
    case "1/16":
      return 1 / 16.0;
    case "1/32":
      return 1 / 32.0;
    default:
      return parseInt(tamano, 10);
  }
}

function alcance(nota) {
  if (nota.guionId.tipoMedio === "Prensa" && (nota.seccion && !isNil(nota.seccion))) {
    return nota.seccion.publicity ? nota.seccion.publicity.alcance : 0;
  }
  return obtenerEdicion(nota).publicity.alcance;
}

function evcomTeleRadio(nota) {
  const evcom = nota.duracion * obtenerEdicion(nota).publicity.precio || 0;
  return isNaN(evcom) ? undefined : evcom;
}

function evcomPrensa(nota) {
  if (isNil(nota.seccion)) {
    nota.seccion = { publicity: false };
  }
  const precio = nota.seccion.publicity ? nota.seccion.publicity.precio : 0;
  const evcom = tamanoToInt(nota.tamanio) * precio;
  return isNaN(evcom) ? undefined : evcom;
}

function calcularEVcom(nota) {
  if (nota.guionId.tipoMedio === "Prensa") {
    return evcomPrensa(nota);
  }
  return evcomTeleRadio(nota);
}

export default {
  data,
  created,
  methods: {
    calcularEVcom,
    alcance,
  },
};
</script>

<style lang="scss">
@import "../../sass/tema/colores";

.panel--nota {
  background: #fff;
  padding: 1.5em;
  border-top: 3px solid $rojo-tema;
}

.ul-notas {
  list-style: none;
  line-height: 1.846;
}

.ul-notas__label {
  display: inline-block;
  font-weight: bold;
  min-width: 128px;
}

.ul-notas__box {
  line-height: 1.846;
  padding-left: 1.5em;
}

.min-height {
  min-height: 324px;
}

.transcripcion {
  resize: none;
  width: 100%;
  min-height: 500px;
  border: 0;
  background: transparent;
}

.mostrar-archivo {
  text-align: left;
  border-bottom: 1px solid #ededed;
  margin-bottom: 1em;
  margin-top: -1em;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/notas/Nota.vue